import { useEffect } from 'react';

import { Card, CardContent } from '@dymaxion/ui';
import { useSessionStore } from '@dymaxion/auth';

/**
 * After a successful POST /auth-api/login, the server returns a
 * redirectUrl. The LoginPage performs the redirect directly; this
 * route exists as a landing target if another flow ever routes here
 * first (e.g. a post-MFA handoff). It shows a brief transition state
 * and performs the redirect.
 */
export function PostAuthRedirectPage() {
  const redirectUrl = useSessionStore((s) => s.redirectUrl);
  const user = useSessionStore((s) => s.user);

  useEffect(() => {
    if (redirectUrl) {
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 600);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [redirectUrl]);

  return (
    <Card className="w-full max-w-md">
      <CardContent className="py-10 text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <p className="text-lg font-medium text-gray-100">
          {user ? `Welcome, ${user.displayName}` : 'Signing you in…'}
        </p>
        <p className="mt-2 text-sm text-gray-60">Redirecting to your workspace.</p>
      </CardContent>
    </Card>
  );
}
